(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$state', '$stateParams', 'Auth'];

    function ActivationController($state, $stateParams, Auth) {
        var vm = this;

        Auth.activateAccount({
            key: $stateParams.key
        }).then(function() {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function() {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = function() {
            $state.go('main-login');
        }
    }
})();
